<template>
  <el-upload
    ref="upload"
    list-type="picture-card"
    class="upload-demo"
    :action="action"
    :with-credentials="true"
    :headers="headers"
    :on-preview="handlePreview"
    :on-remove="handleRemove"
    :on-success="handleSuccess"
    :before-upload="beforeUpload"
    :multiple="multiple"
    :limit="limit"
    :accept="accept"
    v-bind="$attrs"
    :on-exceed="handleExceed"
    :file-list="fileList"
    v-on="$listeners"
  >
    <i class="el-icon-plus" />
    <!-- {{ fileList }} -->
    <div slot="tip" class="el-upload__tip">
      <slot name="tip" />
    </div>
  </el-upload>
</template>

<script>
import { baseURL } from '@/utils/request'
export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    limit: {
      type: Number,
      default: 1,
    },
    limitSize: {
      type: Number,
      default: 15,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: 'image/png,image/jpeg,image/webp',
    },
    action: {
      type: String,
      default: baseURL + '/general/oss/upload',
    },
    typeWarnText: {
      type: String,
      default: '上传文件格式错误',
    },
  },
  data() {
    return {
      fileList: [],
    }
  },
  computed: {
    headers() {
      return {
        // [this.website.tokenHeader]: getToken(),
      }
    },
  },
  watch: {
    value(val) {
      if (!val) {
        this.fileList = []
      } else {
        // 如果upload的文件信息和给到的value信息不同说明需要同步
        this.getFileDetail(val)
      }
    },
  },
  mounted() {
    if (this.value) {
      this.getFileDetail(this.value)
    }
  },
  methods: {
    getFileDetail(val) {
      this.fileList = val.split(',').map((el) => {
        return {
          url: el,
        }
      })
    },
    handleExceed() {
      this.$message.warning('文件个数超出限制')
    },
    handlePreview(file) {
      if (file.url) {
        window.open(file.url, '_blank')
      }
    },
    handleSuccess(res) {
      console.log('upload res', res)
      let url = res.data
      let urls
      if (this.limit > 1) {
        let temArr = (this.value || '').split(',').filter(Boolean)
        temArr.push(url)
        urls = temArr.join(',')
      } else {
        urls = url
      }
      this.$emit('input', urls)
    },
    handleRemove(file) {
      console.log(file)
      let url = file.url
      let tem = this.value
      if (typeof this.value == 'string') {
        tem = this.value.split(',')
      }
      tem = tem.filter((el) => el !== url)
      this.$emit('input', tem.join(','))
    },
    beforeUpload(file) {
      console.log(file)
      if (this.accept.indexOf(file.type) > -1) {
        if (file.size > this.limitSize * 1024 * 1024) {
          this.$message.warning(`文件大小超过 ${this.limitSize} MB, 请重新上传`)
          return false
        }
        return true
      } else {
        this.$message.warning(this.typeWarnText)
        return false
      }
    },
  },
}
</script>

<style></style>
